import { Component, forwardRef, OnInit } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { UserActionFeatureSystemsComponent } from '../userAction-featureSystem/userAction-featureSystem.component';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { ValidFeatureService } from '../../../../Services/validFeature.service';
import { ValidFeatureSystem } from '../../../../Model/ValidFeatureSystem';
import { TranslateService } from '@ngx-translate/core';
import { ViewService } from '../../../../Services/view.service';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';
import { UserActionBaseComponent } from '../userAction-base.component';

@Component({
  selector: 'userAction-scrapProducts',
  templateUrl: 'userAction-scrapProducts.component.html',
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionScrapProductsComponent) }
  ],
  standalone: false
})
export class UserActionScrapProductsComponent extends UserActionBaseComponent {

  private _enrichProducts: boolean = false;
  private _findProducts: boolean = false;
  private _url: string = "";

  urlPattern: RegExp = /^https?:\/\/([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#\[\]@!$&'()*+,;=%]*)?$/;

  get enrichProducts(): boolean {
    return this._enrichProducts;
  }

  set enrichProducts(value: boolean) {
    this._enrichProducts = value;
    if (value) {
      this.findProducts = false;
    }
  }

  get findProducts(): boolean {
    return this._findProducts;
  }

  set findProducts(value: boolean) {
    if (value && !this.hasValidUrl) {
      return; // findProducts kann nur aktiviert werden, wenn eine URL vorhanden ist
    }
    this._findProducts = value;
    if (value) {
      this.enrichProducts = false;
    }
  }

  get url(): string {
    return this._url;
  }

  set url(value: string) {
    this._url = value;
    // Wenn URL entfernt wird, findProducts deaktivieren
    if (!this.hasValidUrl) {
      this._findProducts = false;
    }
  }

  get hasValidUrl(): boolean {
    return this._url.trim().length > 0;
  }

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public systemService: SystemService
  ) {
    super(loginService, macroService);
  }

  public async canStartMacro(): Promise<boolean> {
    if (!(this.enrichProducts || this.findProducts)) {
      this.systemService.notifyInfo(this.translate.instant('mindestens ein Schalter'));
      return false;
    }
    if (this.findProducts && !this.hasValidUrl) {
      this.systemService.notifyInfo(this.translate.instant('URL erforderlich'));
      return false;
    }
    return true;
  }

  parseParameter(parameter: string) {
    try {
      const parsed = JSON.parse(parameter);
      this._url = parsed.url || "";
      this._enrichProducts = parsed.enrichProducts || false;
      this._findProducts = parsed.findProducts || false;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }

  createParameterStringAsJsonString(): string {
    return JSON.stringify({
      enrichProducts: this.enrichProducts,
      findProducts: this.findProducts,
      url: this.url
    });
  }
}